// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderCreatePayerPayload,
    ProviderPayer,
    ProviderPayerSortType,
    SupportCreatePayerPayload,
    SupportPayer,
    SupportPayerSortType,
    SupportReplacePayerPayload,
    SupportUpdatePayerPayload,
    ProviderCreatePayerPayloadToJSON,
    SupportCreatePayerPayloadToJSON,
    SupportReplacePayerPayloadToJSON,
    SupportUpdatePayerPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderPayerFromJSON,
    SupportPayerFromJSON,
} from '../models';

export interface CreateProviderPayerRequest {
    providerCreatePayerPayload: ProviderCreatePayerPayload;
}

export interface CreateSupportPayerRequest {
    supportCreatePayerPayload: SupportCreatePayerPayload;
}

export interface DisableSupportPayerRequest {
    id: string;
}

export interface GetProviderPayerRequest {
    id: string;
}

export interface GetSupportPayerRequest {
    id: string;
}

export interface ListProviderPayersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderPayersOrderEnum>;
    filterHalt?: string;
    filterTag?: Array<string>;
    filterName?: Array<string>;
    filterAddressLines?: Array<string>;
    filterAddressCity?: Array<string>;
    filterAddressState?: Array<string>;
    filterAddressPostalCode?: Array<string>;
    filterAddressCountryCode?: Array<string>;
    filterAddressType?: Array<string>;
    filterEmail?: Array<string>;
    filterPhone?: Array<string>;
    filterFax?: Array<string>;
    filterCoverageType?: Array<string>;
    filterCreated?: Array<string>;
    sort?: Array<ProviderPayerSortType>;
}

export interface ListSupportPayersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportPayersOrderEnum>;
    filterHalt?: string;
    filterStarred?: string;
    filterActive?: string;
    filterTag?: Array<string>;
    filterName?: Array<string>;
    filterAddressLines?: Array<string>;
    filterAddressCity?: Array<string>;
    filterAddressState?: Array<string>;
    filterAddressPostalCode?: Array<string>;
    filterAddressCountryCode?: Array<string>;
    filterAddressType?: Array<string>;
    filterEmail?: Array<string>;
    filterPhone?: Array<string>;
    filterFax?: Array<string>;
    filterCoverageType?: Array<string>;
    filterCreated?: Array<string>;
    sort?: Array<SupportPayerSortType>;
}

export interface ReplaceSupportPayerRequest {
    supportReplacePayerPayload: SupportReplacePayerPayload;
}

export interface UpdateSupportPayerRequest {
    id: string;
    supportUpdatePayerPayload: SupportUpdatePayerPayload;
}

/**
 * no description
 */
export class PayerApi extends runtime.BaseAPI {

    /**
     * Creates a payer. The created payer name is always prefixed with \"Generated Payer - \" for later processing.
     * Create a payer
     */
    async createProviderPayerRaw(requestParameters: CreateProviderPayerRequest): Promise<runtime.ApiResponse<ProviderPayer>> {
        if (requestParameters['providerCreatePayerPayload'] === null || requestParameters['providerCreatePayerPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreatePayerPayload','Required parameter requestParameters.providerCreatePayerPayload was null or undefined when calling createProviderPayer.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:payer"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/payer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreatePayerPayloadToJSON(requestParameters['providerCreatePayerPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderPayerFromJSON(jsonValue));
    }

    /**
     * Creates a payer. The created payer name is always prefixed with \"Generated Payer - \" for later processing.
     * Create a payer
     */
    async createProviderPayer(requestParameters: CreateProviderPayerRequest): Promise<ProviderPayer> {
        const response = await this.createProviderPayerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a payer
     * Create a payer
     */
    async createSupportPayerRaw(requestParameters: CreateSupportPayerRequest): Promise<runtime.ApiResponse<SupportPayer>> {
        if (requestParameters['supportCreatePayerPayload'] === null || requestParameters['supportCreatePayerPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreatePayerPayload','Required parameter requestParameters.supportCreatePayerPayload was null or undefined when calling createSupportPayer.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:payer", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreatePayerPayloadToJSON(requestParameters['supportCreatePayerPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportPayerFromJSON(jsonValue));
    }

    /**
     * Creates a payer
     * Create a payer
     */
    async createSupportPayer(requestParameters: CreateSupportPayerRequest): Promise<SupportPayer> {
        const response = await this.createSupportPayerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a payer
     * Disable a payer
     */
    async disableSupportPayerRaw(requestParameters: DisableSupportPayerRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportPayer.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:payer", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payer/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a payer
     * Disable a payer
     */
    async disableSupportPayer(requestParameters: DisableSupportPayerRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportPayerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a payer
     * Get a payer
     */
    async getProviderPayerRaw(requestParameters: GetProviderPayerRequest): Promise<runtime.ApiResponse<ProviderPayer>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderPayer.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payer"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/payer/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderPayerFromJSON(jsonValue));
    }

    /**
     * Gets a payer
     * Get a payer
     */
    async getProviderPayer(requestParameters: GetProviderPayerRequest): Promise<ProviderPayer> {
        const response = await this.getProviderPayerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a payer
     * Get a payer
     */
    async getSupportPayerRaw(requestParameters: GetSupportPayerRequest): Promise<runtime.ApiResponse<SupportPayer>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportPayer.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payer", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payer/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportPayerFromJSON(jsonValue));
    }

    /**
     * Gets a payer
     * Get a payer
     */
    async getSupportPayer(requestParameters: GetSupportPayerRequest): Promise<SupportPayer> {
        const response = await this.getSupportPayerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of payers
     * Get a list of payers
     */
    async listProviderPayersRaw(requestParameters: ListProviderPayersRequest): Promise<runtime.ApiResponse<Array<ProviderPayer>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterHalt !== undefined) {
            queryParameters['filterHalt'] = requestParameters.filterHalt;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterName) {
            queryParameters['filterName'] = requestParameters.filterName;
        }

        if (requestParameters.filterAddressLines) {
            queryParameters['filterAddressLines'] = requestParameters.filterAddressLines;
        }

        if (requestParameters.filterAddressCity) {
            queryParameters['filterAddressCity'] = requestParameters.filterAddressCity;
        }

        if (requestParameters.filterAddressState) {
            queryParameters['filterAddressState'] = requestParameters.filterAddressState;
        }

        if (requestParameters.filterAddressPostalCode) {
            queryParameters['filterAddressPostalCode'] = requestParameters.filterAddressPostalCode;
        }

        if (requestParameters.filterAddressCountryCode) {
            queryParameters['filterAddressCountryCode'] = requestParameters.filterAddressCountryCode;
        }

        if (requestParameters.filterAddressType) {
            queryParameters['filterAddressType'] = requestParameters.filterAddressType;
        }

        if (requestParameters.filterEmail) {
            queryParameters['filterEmail'] = requestParameters.filterEmail;
        }

        if (requestParameters.filterPhone) {
            queryParameters['filterPhone'] = requestParameters.filterPhone;
        }

        if (requestParameters.filterFax) {
            queryParameters['filterFax'] = requestParameters.filterFax;
        }

        if (requestParameters.filterCoverageType) {
            queryParameters['filterCoverageType'] = requestParameters.filterCoverageType;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payer"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/payer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderPayerFromJSON));
    }

    /**
     * Gets a list of payers
     * Get a list of payers
     */
    async listProviderPayers(requestParameters: ListProviderPayersRequest): Promise<Array<ProviderPayer>> {
        const response = await this.listProviderPayersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of payers
     * Get a list of payers
     */
    async listSupportPayersRaw(requestParameters: ListSupportPayersRequest): Promise<runtime.ApiResponse<Array<SupportPayer>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterHalt !== undefined) {
            queryParameters['filterHalt'] = requestParameters.filterHalt;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterName) {
            queryParameters['filterName'] = requestParameters.filterName;
        }

        if (requestParameters.filterAddressLines) {
            queryParameters['filterAddressLines'] = requestParameters.filterAddressLines;
        }

        if (requestParameters.filterAddressCity) {
            queryParameters['filterAddressCity'] = requestParameters.filterAddressCity;
        }

        if (requestParameters.filterAddressState) {
            queryParameters['filterAddressState'] = requestParameters.filterAddressState;
        }

        if (requestParameters.filterAddressPostalCode) {
            queryParameters['filterAddressPostalCode'] = requestParameters.filterAddressPostalCode;
        }

        if (requestParameters.filterAddressCountryCode) {
            queryParameters['filterAddressCountryCode'] = requestParameters.filterAddressCountryCode;
        }

        if (requestParameters.filterAddressType) {
            queryParameters['filterAddressType'] = requestParameters.filterAddressType;
        }

        if (requestParameters.filterEmail) {
            queryParameters['filterEmail'] = requestParameters.filterEmail;
        }

        if (requestParameters.filterPhone) {
            queryParameters['filterPhone'] = requestParameters.filterPhone;
        }

        if (requestParameters.filterFax) {
            queryParameters['filterFax'] = requestParameters.filterFax;
        }

        if (requestParameters.filterCoverageType) {
            queryParameters['filterCoverageType'] = requestParameters.filterCoverageType;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payer", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportPayerFromJSON));
    }

    /**
     * Gets a list of payers
     * Get a list of payers
     */
    async listSupportPayers(requestParameters: ListSupportPayersRequest): Promise<Array<SupportPayer>> {
        const response = await this.listSupportPayersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replace a payer
     * Replace a payer
     */
    async replaceSupportPayerRaw(requestParameters: ReplaceSupportPayerRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReplacePayerPayload'] === null || requestParameters['supportReplacePayerPayload'] === undefined) {
            throw new runtime.RequiredError('supportReplacePayerPayload','Required parameter requestParameters.supportReplacePayerPayload was null or undefined when calling replaceSupportPayer.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payer", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payer/replace`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReplacePayerPayloadToJSON(requestParameters['supportReplacePayerPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replace a payer
     * Replace a payer
     */
    async replaceSupportPayer(requestParameters: ReplaceSupportPayerRequest): Promise<ObjectNoResponse> {
        const response = await this.replaceSupportPayerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a payer
     * Update a payer
     */
    async updateSupportPayerRaw(requestParameters: UpdateSupportPayerRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportPayer.');
        }

        if (requestParameters['supportUpdatePayerPayload'] === null || requestParameters['supportUpdatePayerPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdatePayerPayload','Required parameter requestParameters.supportUpdatePayerPayload was null or undefined when calling updateSupportPayer.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payer", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payer/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdatePayerPayloadToJSON(requestParameters['supportUpdatePayerPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a payer
     * Update a payer
     */
    async updateSupportPayer(requestParameters: UpdateSupportPayerRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportPayerRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderPayersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportPayersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
